import { parseCookies } from '@cian/utils';
import { setCookie } from '@cian/utils/lib/browser/cookie';
import * as React from 'react';

import { OfferMessageTooltipContext, OfferMessageTooltipState } from './context';

type TOfferMessageTooltipProviderProps = {
  children: React.ReactNode;
  rootRef: React.RefObject<HTMLDivElement | null>;
};

export const OfferMessageTooltipProvider: React.FC<TOfferMessageTooltipProviderProps> = ({ children, rootRef }) => {
  const [tooltipState, setTooltipState] = React.useState<OfferMessageTooltipState | null>(null);

  const showTooltip = React.useCallback((offerId: number) => {
    setTooltipState(current => {
      const parsedCookieObject = parseCookies(document.cookie);
      if (current?.isVisible || parsedCookieObject['expert_tooltip_visible']) {
        return current;
      }

      setCookie('expert_tooltip_visible', '1', { secure: false });

      return { offerId, isVisible: true };
    });
  }, []);

  const hideTooltip = React.useCallback(() => {
    setTooltipState(null);
  }, []);

  const contextValue = React.useMemo(
    () => ({
      offerMessageTooltipState: tooltipState,
      rootRef,
      showTooltip,
      hideTooltip,
    }),
    [tooltipState, showTooltip, hideTooltip, rootRef],
  );

  return <OfferMessageTooltipContext.Provider value={contextValue}>{children}</OfferMessageTooltipContext.Provider>;
};
